import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ICompany } from '../../../companies/models/company.interface';

@Component({
  selector: 'app-company-sidebar',
  templateUrl: './company-sidebar.component.html'
})
export class CompanySidebarComponent {
  @Input() companies: ICompany[] = [];
  @Input() selectedCompanyId: string | null = null;
  @Input() disabled = false;

  @Output() companySelected = new EventEmitter<string>();

  expanded = false;
  searchTerm = '';

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  get filteredCompanies(): ICompany[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      return this.companies;
    }

    return this.companies.filter((company) => `${company.name} ${company.trading}`.toLowerCase().includes(term));
  }

  toggleExpanded(): void {
    if (this.disabled) {
      return;
    }
    this.expanded = !this.expanded;
  }

  selectCompany(company: ICompany): void {
    if (this.disabled || !company.id) {
      return;
    }
    this.companySelected.emit(company.id);
    this.expanded = false;
    this.searchTerm = '';
  }

  getInitials(company: ICompany): string {
    return (company.name || '?').trim().charAt(0).toUpperCase();
  }

  // composedPath() é fixado no disparo do evento: continua valendo mesmo se o alvo sair do DOM
  // no meio do clique (o lucide-icon recria o <svg> ao trocar o ícone de abrir/recolher).
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.expanded && !event.composedPath().includes(this.elementRef.nativeElement)) {
      this.expanded = false;
    }
  }
}
